import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Separate partials
import awaveLogotype from "../../assets/images/awave-logotyp.svg";
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

class Header extends Component {

	constructor(props){
        super(props);

        this.state = {
            menuVisible: false
        }

        this.toggleHamburger = this.toggleHamburger.bind(this);
	}
	
	toggleHamburger() {
        this.setState({
            menuVisible: !this.state.menuVisible
        })
    }

    render() {
		
        return (
			<Fragment>
				<header className="awave-header">
					<a href="#/page/1" className="awave-site-logotype">
						<img src={ awaveLogotype } className="awave-logotype" alt="Awave Logotype" />
					</a>
					
					<button className="searchButton">
						<FontAwesomeIcon icon={faSearch} />
					</button>

					<button
						onClick={() => this.toggleHamburger()}
						className={this.state.menuVisible ? 'hamburger-button visible' : 'hamburger-button'}>
						<span className="burger"></span>
						<span className="topping"></span>
					</button>
				</header>

				<nav className="primary-navigation"></nav>

			</Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        // mainMenuItems:state.psagot.mainMenuItems,
        // mainMenuLoading:state.psagot.mainMenuLoading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        //getMenu:()=>dispatch(getMenu())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header)


// WEBPACK FOOTER //
// ./src/frontend/components/UI/Header.js